/**
 * @fileoverview home-context.ts — shared actions for the Projects-home blocks.
 * @module apps/network/consumer/src/home/home-context
 *
 * Blocks read their own data via the global IO hooks; the only thing they need
 * from the host screen is a couple of imperative actions (open the New-project
 * wizard). A tiny keyed context keeps blocks decoupled from ProjectsHome —
 * navigation they do directly via svelte-spa-router's `push`.
 */

import { getContext, setContext } from "svelte";

export interface HomeActions {
  /** Open the New-project wizard. */
  openNewProject(): void;
}

const HOME_ACTIONS_KEY: unique symbol = Symbol("projects.home.actions");

/** Host screen (ProjectsHome) provides the actions. */
export function provideHomeActions(actions: HomeActions): void {
  setContext(HOME_ACTIONS_KEY, actions);
}

/** Blocks consume them. Falls back to a no-op so a block rendered outside the
 *  home (e.g. in isolation) never throws. */
export function useHomeActions(): HomeActions {
  return (
    getContext<HomeActions | undefined>(HOME_ACTIONS_KEY) ?? {
      openNewProject() {
        /* no-op outside the home */
      },
    }
  );
}
